module.exports = __webpack_public_path__ + "static-portal/img/55-1.425819f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/55-1.jpg
// module id = oJ9+
// module chunks = 4